const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL?.trim() ?? '';
const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY?.trim() ?? '';

export const env = {
  supabaseUrl: SUPABASE_URL,
  supabaseAnonKey: SUPABASE_ANON_KEY,
  mockAuthEmail: import.meta.env.VITE_MOCK_AUTH_EMAIL?.trim() ?? 'demo@boxme.asia',
  mockAuthPassword: import.meta.env.VITE_MOCK_AUTH_PASSWORD?.trim() ?? 'demo1234',
  isMock: SUPABASE_URL === '' || SUPABASE_ANON_KEY === '',
} as const;
